export type ErrorCategory = 'game' | 'tournaments' | 'jackpot' | 'general';

export interface ErrorLogData {
  error: Error;
  errorInfo?: React.ErrorInfo;
  errorCategory: ErrorCategory;
  componentName?: string;
  additionalData?: Record<string, unknown>;
}

const logErrorBoundaryError = ({
  error,
  errorInfo,
  errorCategory,
  componentName,
  additionalData = {}
}: ErrorLogData) => {
  // Generate unique error ID
  const errorId = `error_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  // Detailed error logging
  console.error(`[${errorCategory}ErrorBoundary] Error caught:`, {
    errorId,
    componentName,
    error: {
      message: error.message,
      stack: error.stack,
      name: error.name,
    },
    errorInfo,
    additionalData,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    url: window.location.href,
  });

  return errorId;
};

export const createErrorHandler = (
  errorCategory: ErrorCategory,
  componentName?: string
) => {
  return (error: unknown, errorInfo: React.ErrorInfo) => {
    logErrorBoundaryError({
      error: error as Error,
      errorInfo,
      errorCategory,
      componentName,
    });
  };
};
